import { createSelector } from 'reselect';
const getMakeTFL = (state) => state?.config?.makeTFL;

export const getMakeTFLState = createSelector(
    [getMakeTFL],
    (makeTFL) => makeTFL
);
